export default {
  state: {
    currentAnimationName: "",
    currentVoiceOverName: ""
  },
  mutations: {
    updateCurrentAnimation(state, payload) {
      state.currentAnimationName = payload;
    },
    updateCurrentVoiceOverName(state, payload) {
      state.currentVoiceOverName = payload;
    }
  }
};
